// src/components/Highlights.js
import React, { useState } from 'react';
import './Highlights.css';

const highlights = [
  {
    title: "National Semi-Finalist - Flipkart GRiD 7.0",
    date: "August 2025",
    description:
      "Finished as a National Semi-Finalist at Flipkart GRiD 7.0."
  },
  {
    title: "Semi-Finalist - HackOn With Amazon Season 5",
    date: "June 2025",
    description:
      "Amongst the top 130 out of 14971 teams."
  },
  {
    title: "Top 10 - ML Hackathon by IIT Kanpur",
    date: "March 2025",
    description:
      "Finished top 10 in the ML Hackathon, conducted as a part of Techkriti'25 - IIT Kanpur."
  },
  {
    title: "Winner - AI Finance Hackathon by IIT Kanpur",
    date: "March 2025",
    description:
      "Secured the 1st Position at the AI Finance Hackathon, conducted as a part of Techkriti'25 - IIT Kanpur, in collaboration with National Financial Reporting Authority (NFRA), Government of India."
  },
  {
    title: "Presented Research Paper at an International Conference",
    date: "March 2025",
    description:
      "My research paper was one of the 400 out of 800 abstracts to get selected for Oral Presentation at the International Conference on Space for Sustainability: Space, Technology, Education, Policy. The session was chaired by Dr. Bulbul Mukherjee, Scientist, ISRO, Government of India. The conference was held by Centre for Space Science and Technology (CSST), Indian Institute of Technology Roorkee in association with ISRO, IN-SPACe, ASI, IPSA, IAA."
  },
  {
    title: "Co-Secretary at BIF-VIT",
    date: "December 2024",
    description:
      "Organised regular outreach events to teach underprivileged children in Vellore, India. Conducted events that aligned with the club's motto \"where others teach, we educate\"."
  },
  {
    title: "Smart India Hackathon College Representative",
    date: "September 2024",
    description:
      "As the team leader, got my team selected by my university out of 400+ teams to represent Vellore Institute of Technology, Vellore in Smart India Hackathon 2024."
  },
  {
    title: "Third Place - CodeChef-VIT Internal Hackathon",
    date: "August 2024",
    description:
      "Secured the 3rd position at CodeChef-VIT's Internal Hackathon."
  },
  {
    title: "Second Position - Helios Hackathon",
    date: "March 2024",
    description:
      "Secured the 2nd position at Helios, a hackathon conducted by Students for the Exploration and Development of Space, VIT Vellore."
  }
];

const Highlights = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="highlights" className="highlights-container">
      <div className="highlights-header">
        <h2>Highlights</h2>
        <div className="header-underline"></div>
      </div>
      <div className="highlights-timeline">
        {highlights.map((item, index) => (
          <div className={`highlight-item ${openIndex === index ? "active" : ""}`} key={index}>
            <div className="timeline-dot"></div>
            <div className="highlight-card" onClick={() => toggleItem(index)}>
              <div className="card-header">
                <h3>{item.title}</h3>
                <span className="date">{item.date}</span>
                <button className="expand-btn">{openIndex === index ? "−" : "+"}</button>
              </div>
              <div
                className={`card-description ${
                  openIndex === index ? "show" : ""
                }`}
              >
                {item.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Highlights;